import Rellax from "../vendor/rellax";

var rellax = new Rellax('.rellax');
